import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseObservationLogsKey } from '@/hooks'
import { APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePostObservationLogsBulkApprove = (): UseMutationResult<
  void,
  APIErrorResponse,
  number[]
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const queryKey = getUseObservationLogsKey()

  return useMutation(
    async (ids: number[]) => {
      await client
        .post('/plannings/observation_logs/approve-batch/', { ids })
        .then(unwrapResponse)
        .catch(unwrapErrorResponse)
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKey)
      },
    }
  )
}
